"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const HelloGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "HELLO-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.585 19.934a.5.5 0 0 1 .5.5v3.067a.5.5 0 1 1-1 0v-3.067a.5.5 0 0 1 .5-.5m12.333-4.77a2.028 2.028 0 0 1 2.872 0c.792.794.793 2.08 0 2.875l-2.856 2.863a3.555 3.555 0 0 1-4.741.263l-.988-.792V23.5a.5.5 0 1 1-1 0v-4.17a.5.5 0 0 1 .813-.39l1.8 1.443a2.555 2.555 0 0 0 3.408-.189l2.856-2.862a1.036 1.036 0 0 0 0-1.462 1.028 1.028 0 0 0-1.456 0l-2.856 2.862a.5.5 0 0 1-.667.038l-1.917-1.535a4.083 4.083 0 0 0-2.552-.902h-3.52a4.095 4.095 0 0 0-4.09 4.1v3.067a.5.5 0 1 1-1 0v-3.067c0-2.817 2.28-5.1 5.09-5.1h3.52a5.083 5.083 0 0 1 3.178 1.122l1.566 1.254ZM6.645 7.667a3.564 3.564 0 0 1 3.56 3.567 3.564 3.564 0 0 1-3.56 3.567 3.564 3.564 0 0 1-3.56-3.567 3.564 3.564 0 0 1 3.56-3.567Zm0 1a2.564 2.564 0 0 0-2.56 2.567 2.564 2.564 0 0 0 2.56 2.567 2.564 2.564 0 0 0 2.56-2.567 2.564 2.564 0 0 0-2.56-2.567M21.945 0c1.122 0 2.03.91 2.03 2.033v6.134a2.032 2.032 0 0 1-2.03 2.034h-3.649l-3.688 2.957a.5.5 0 0 1-.813-.39V10.2h-1.03c-1.121 0-2.03-.91-2.03-2.034V2.032C10.735.91 11.644 0 12.765 0h9.18Zm0 1h-9.18c-.569 0-1.03.462-1.03 1.033v6.134c0 .571.461 1.034 1.03 1.034h1.53a.5.5 0 0 1 .5.5v2.025l3.012-2.415a.5.5 0 0 1 .313-.11h3.825c.57 0 1.03-.463 1.03-1.034V2.032c0-.57-.46-1.033-1.03-1.033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17 3.098a.5.5 0 0 1 .5.5v3.067a.5.5 0 0 1-1 0V3.598a.5.5 0 0 1 .5-.5m-5.577-.03a.5.5 0 0 1 .5.5v1.034h1.79l.001-1.01a.5.5 0 0 1 .41-.493l.09-.008a.5.5 0 0 1 .5.5v3.067a.5.5 0 1 1-1 0V5.602h-1.791v1.034a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5V3.569a.5.5 0 0 1 .5-.5"
  }))));
};
HelloGraphicIcon.displayName = "HelloGraphicIcon";
HelloGraphicIcon.iconName = "Hello";
export default HelloGraphicIcon;